import { render, staticRenderFns } from "./rainbow-gradient.vue?vue&type=template&id=c89a1b04&functional=true&"
import script from "./rainbow-gradient.vue?vue&type=script&lang=js&"
export * from "./rainbow-gradient.vue?vue&type=script&lang=js&"
import style0 from "./rainbow-gradient.vue?vue&type=style&index=0&id=c89a1b04&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports